(() => {
  'use strict';
  if (window.AimiiFocus) return;
  window.AimiiFocus = true;
  const root = document.documentElement;
  const setInput = input => { if (root.dataset.aimiiInput !== input) root.dataset.aimiiInput = input; };
  document.addEventListener('pointerdown', () => setInput('pointer'), {capture: true, passive: true});
  document.addEventListener('keydown', event => {
    if (event.metaKey || event.ctrlKey || event.altKey || ['Shift', 'Control', 'Alt', 'Meta', 'CapsLock'].includes(event.key)) return;
    setInput('keyboard');
  }, {capture: true});
})();
